import React from "react";
import './Three.css'
import img1 from './Image/post1.jpg'
import img2 from './Image/post2.jpg'
import img3 from './Image/post3.jpg'



const ContentPost = () => {
  
  const AI1 = [
    {
      img: img1,
      level: '1:1 - 1080 X 1080 PX',
    },
    {
      img: img2,
      level: '16:9 - 1920 X 1080 PX',
    },
    {
      img: img3,
      level: '9: 16 - 1080 X 1920 PX',
    },
  ]

  return (
    <div className="text-white">
      <div className="text-center">
        <p className="postAI-title"><span className="fw-bold">Quote</span> : Motivational quote</p>
        <div className="postAI-image">
              {AI1.map((item, index) => (
                <div
                key={index}
                >
                  <img
                  src={item.img}
                  alt={`Item ${index + 1}`}
                //   style={{ width: "256px", height: "256px", margin: "10px" }}
                />
                <p className="mt-2 mb-4">{item.level}</p>
                </div>
              ))}
        </div>

      </div>
    </div>
  );
};

export default ContentPost;
